<template>
  <l-layout :layout="['xs12']">
    <reservation-form :type="type" :authority="auth" :reservation="newReservation" :status="status" :id="id" @updateReservation="setReservation"></reservation-form>
  </l-layout>
</template>

<script>
import ReservationForm from '../Common/reservationForm'
import {ReservationGroup, ReservationAuthority, Reservation} from '../../../object'

export default {
  name: 'PersonNewGroupReservation',
  components: {ReservationForm},
  data: () => ({
    type: Reservation.ADMIN,
    newReservation: new ReservationGroup(),
    status: '',
    id: ''
  }),
  computed: {
    auth () {
      return this.$store.state.personReservation.adminAuth
    }
  },
  created () {
    if (this.$route.query.status !== undefined) {
      this.status = this.$route.query.status
    }
    if (this.$route.query.id !== undefined) {
      this.id = this.$route.query.id
    }
  },
  activated () {
    if (this.$route.query.status !== undefined) {
      this.status = this.$route.query.status
    }
    if (this.$route.query.id !== undefined) {
      this.id = this.$route.query.id
    }
  },
  methods: {
    setReservation (data) {
      this.newReservation.name=data.obgrp.name
      this.newReservation.description = data.obgrp.description
      this.newReservation.id = data.obgrp.id
    }
  }
}
</script>

<style scoped>

</style>
